// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAppDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.799 10.882a2.798 2.798 0 1 1-5.596 0 2.798 2.798 0 0 1 5.596 0zM12.001 12.27V9.378"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m13.581 10.876-1.58 1.58-1.581-1.58"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.067 2.85v18.3c0 .817-.662 1.479-1.478 1.479H6.415a1.478 1.478 0 0 1-1.477-1.478V2.849c0-.816.661-1.478 1.477-1.478H17.59c.816 0 1.478.662 1.478 1.478z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.133 18.175H6.868V3.264h10.265z"
    />
    <path
      fill="currentColor"
      d="M13.029 20.414a1.029 1.029 0 1 1-2.057 0 1.029 1.029 0 0 1 2.057 0z"
    />
  </svg>
);
export default SvgAppDownload;
